module.exports = __webpack_public_path__ + "static/media/02-final.a4732894.webp";